import React, {useEffect, useMemo, useState} from "react";
import {
    ListItem,
    Box,
    Grid,
    CircularProgress,
    List, ListItemText, Checkbox, Button, Badge
} from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import {Service} from "~/apps/packages/auto-visits/queries";
import {PortTheme} from "~/ui/theme";
import {BottomSheet} from "~/apps/core/ui/BottomSheet";
import {useServiceList} from "~/apps/packages/auto-visits/hooks";
import {compareByField} from "~/apps/core/utils";
import {FloatingActions} from "~/apps/core/ui/FloatingActions";


export type ServiceSelectDialogProps = {
    carrierId: string
    cargoId: string
    autoVisitId?: string
    open?: boolean
    onClose?: () => any
    value?: Service[]
    onChange?: (value: Service[]) => any
}


const useStyles = makeStyles<PortTheme, ServiceSelectDialogProps>(theme => ({
    badge: {
        "& .MuiBadge-badge": {
            position: "inherit !important",
            transform: "none",
        },
    }
}));


export const ServiceSelectDialog = (props: ServiceSelectDialogProps) => {
    const {open, onClose, cargoId, carrierId, autoVisitId, value, onChange} = props;
    const classes = useStyles(props);
    const [selectedServices, setSelectedServices] = useState<Service[]>(value || []);
    const selectedIDs = useMemo(() => new Set(selectedServices?.map(x => x.ID)), [selectedServices]);
    const countSelected = useMemo(() => {
        return selectedServices.filter(s => !s.Necessary).length;
    }, [selectedServices])

    const {data, loading} = useServiceList({carrierId, cargoId, autoVisitId});
    const items = useMemo(() => {
        return data ? [...data].sort(compareByField("Name")).filter(s => !s.Necessary) : undefined;
    }, [data]);

    useEffect(() => {
        if (!open) {
            setSelectedServices([]);
        }
    }, [open]);

    useEffect(() => {
        setSelectedServices(value || []);
    }, [value])


    const handleItemClick = (service: Service) => (e: React.SyntheticEvent) => {
        e.stopPropagation();
        setSelectedServices(services => {
            if (services.find(s => s.ID == service.ID)) {
                return services.filter(s => s.ID != service.ID);
            } else {
                return [...services, service];
            }
        });
    };

    const handleApplyClick = () => {
        onChange && onChange(selectedServices);
    }

    const handleResetClick = () => {
        setSelectedServices(services => services.filter(s => s.Necessary));
    }

    return (
        <>
            <BottomSheet title="Дополнительные услуги" open={open} onClose={onClose}>
                {loading && (
                    <Grid container justifyContent="center">
                        <Box p={2}>
                            <CircularProgress/>
                        </Box>
                    </Grid>
                )}
                {items?.length > 0 && (
                    <>
                        <List disablePadding>
                            {items.map((item) => {
                                const selected = selectedIDs.has(item.ID)
                                return (
                                    <ListItem key={item.ID} onClick={handleItemClick(item)}>
                                        <ListItemText primary={item.Name}/>
                                        <Checkbox
                                            edge="end"
                                            color="additionalPrimary"
                                            checked={selected}
                                            onClick={handleItemClick(item)}
                                        />
                                    </ListItem>
                                )
                            })}
                        </List>
                    </>
                )}
                <Box minHeight={136}/>
                <FloatingActions>
                    <Button
                        color="additionalPrimary"
                        fullWidth
                        endIcon={(
                            <Badge
                                badgeContent={countSelected}
                                showZero
                                className={classes.badge}
                                color="onAdditionalPrimary"
                            />
                        )}
                        onClick={handleApplyClick}
                        disabled={loading}
                    >
                        Применить
                    </Button>
                    <Button color="secondary" fullWidth onClick={handleResetClick} disabled={loading}>
                        Сбросить
                    </Button>
                </FloatingActions>
            </BottomSheet>
        </>
    )
}